import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { PROPERTY_BLOCK } from "./apiRoutes";

const mutateAddPropertyBlock = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${PROPERTY_BLOCK(data?.communityId)}`, data);
};

const useAddPropertyBlockMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddPropertyBlock,
    ...queryParams,
  });

export default useAddPropertyBlockMutation;
